import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from './utils';

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
    error?: boolean;
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    ({ className, error, ...props }, ref) => {
        return (
            <input
                ref={ref}
                type="checkbox"
                className={cn('nx-checkbox', error && 'nx-checkbox--error', className)}
                aria-invalid={error || props['aria-invalid'] ? true : undefined}
                {...props}
            />
        );
    },
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
export type { CheckboxProps };
